import { FC } from "react";
import { capitalize, Stack } from "@mui/material";
import type { CustomHeaderProps } from "ag-grid-react";
import { ResourceExplorerGroupingNullable } from "@/services/cloudchipr.api";
import { ColumnsInnerHeaderComponent } from "@/components/pages/common/ag-grid/components/ColumnsInnerHeaderComponent";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { useAppSelector } from "@/store/hooks";
import { resourceExplorerGroupingLabelByGroupingSelector } from "@/store/resource-explorer/selectors/possible-groupings/resourceExplorerGroupingLabelByGroupingSelector";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";

interface InnerHeaderComponentParamsProps {
  grouping?: ResourceExplorerGroupingNullable;
  totalItemsCount?: number;
}

export const BillingExplorerWidgetLabelHeaderCell: FC<
  CustomHeaderProps<ResourceExplorerGridDataWithId>
> = ({ innerHeaderComponentParams, ...props }) => {
  const { grouping, totalItemsCount }: InnerHeaderComponentParamsProps =
    innerHeaderComponentParams;

  const groupingLabel = useAppSelector((state) =>
    resourceExplorerGroupingLabelByGroupingSelector(state, grouping),
  );

  const formattedGrouping = grouping
    ?.split("_")
    ?.map((word) => capitalize(word))
    ?.join(" ");

  return (
    <Stack position="relative" width="100%">
      <ColumnsInnerHeaderComponent
        {...props}
        displayName={groupingLabel?.singular ?? formattedGrouping ?? "Grouping"}
      />

      <TypographyWithTooltip
        fontSize={10}
        variant="caption"
        title={totalItemsCount}
      />
    </Stack>
  );
};
